import { all, call, put, takeLatest } from 'redux-saga/effects';

import {
  getAdminConfigSuccess,
  getAdminConfigFail,
  exportQuotationsStatsSuccess,
  exportQuotationsStatsFail,
} from './actions';

import { GET_ADMIN_CONFIG_REQUEST, EXPORT_QUOTATIONS_STATS_REQUEST } from './actionTypes';

import { logout } from '../Auth/actions';
import { getOptions, processResponse } from '../../Utils/Utils';
import { API, fetchFromApi } from '../apis';

function* getAdminConfig() {
  const { response, error } = yield call(fetchFromApi, getOptions({ url: API.stats.GET_ADMIN_CONFIG() }));
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(getAdminConfigSuccess(data));
      break;
    case 'fail':
      yield put(getAdminConfigFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* exportQuotationsStats({ params }) {
  const { response, error } = yield call(fetchFromApi, getOptions({ url: API.stats.EXPORT_QUOTATIONS(), params }));
  const { type, data, alerts } = processResponse({ response, error });

  switch (type) {
    case 'success':
      yield put(exportQuotationsStatsSuccess({ data, params }));
      break;
    case 'fail':
      yield put(exportQuotationsStatsFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* watchSalesRoutes() {
  yield all([
    yield takeLatest(EXPORT_QUOTATIONS_STATS_REQUEST, exportQuotationsStats),
    yield takeLatest(GET_ADMIN_CONFIG_REQUEST, getAdminConfig),
  ]);
}

export default watchSalesRoutes;
